import { ContentActions, ContentActionsTypes } from '../actions/actions-content';
import { ContentPage } from '../models/models-content';

export interface State {
  isLoading: boolean;
  contentPage: ContentPage;
}

/* eslint-disable */
function getInitialState(): State {
  return {
    isLoading: false,
    contentPage: {} as ContentPage
  };
}

const initialState: State = getInitialState();

/* eslint-disable */
export function reducer(state = initialState, action: ContentActions): State {
  switch (action.type) {
    case ContentActionsTypes.InitContentPage: {
      return { ...getInitialState(), isLoading: true };
    }

    case ContentActionsTypes.SetContentPage: {
      return { ...state, isLoading: false, contentPage: action.payload.contentPage };
    }

    default:
      return state;
  }
}
